module.exports = __webpack_public_path__ + "img/green-arrow-up.1b3afb6e.svg";